import { Component, OnInit, NgZone } from '@angular/core';
declare var $: any;
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl } from '@angular/forms';
import { TranslateService } from '../../../_services/translate.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { AnpiService } from '../../../_services/anpi-code.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  public languageForm: FormGroup;
  response: any
  notificationDetails: any
  notificationList: any;
  url: any;
  constructor(private translate: TranslateService,
    private api: ApiService,
    private router: Router,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private location: Location) {}


  ngOnInit() {

    this.getEmployeeNotfication();

  }

  naviagteToPage(navigateUrl, NotificationId) {
    /// call the api for status change ++SUBY
    this.router.navigate([navigateUrl]);
  }


  getEmployeeNotfication() {

    this.ngxUiLoaderService.start();
    this.api.getNotfication().pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res;
          if (this.response.status == 200) {
            // console.log(this.response.results);
            this.notificationList = this.response.results;
            this.notificationDetails = this.response.results;
            console.log(this.notificationDetails);
            const filteredNotifications = this.notificationList.filter(notification => notification.view_status === 0);

            const viewedNotification = filteredNotifications.map(notification => {
              return {
                notification_id: notification.notification_id,
                status: notification.push
              };
            });
            const data = {
              result : viewedNotification}
            this.updateNotification(data);
            console.log("65", viewedNotification)

          } else {
            console.log("57")
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  updateNotification(data) {
    console.log(data)
    if (data) {
      this.api.updateNotificationList(data).pipe(first())
        .subscribe(res => {
            this.response = res;
            if (this.response.status == 200) {
              console.log(this.response)
            } else {

            }
          },
          error => {});
    }

  }
  showSearch() {
    console.log('333')
    $('#searchStyle').addClass('searchTransform');
    $('#searchInput').addClass('changeSearchStyle');
    $('small').css({ display: "none" });

  }

  setFilteredNotification(e: any) {
    console.log(e)
    this.notificationDetails = this.notificationList.filter((notifcationList: any) => {
      if (notifcationList.title != null) {
        return notifcationList.title.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1;
      }
    });
  }
  goToView(page, id) {

    console.log(page, id)
    // return
    switch (page) {
      case 'dashboard':
        {
          if (this.url == 'dashboard') {
            window.location.reload();
          }
          this.router.navigate(['/dashboard']);
          break;
        }
      case 'employees':
        {
          if (this.url == 'employees') {
            window.location.reload();
          } else {
            this.router.navigate(['/employees']);
          }

          break;
        }
      case 'employee-list':
        {
          this.router.navigate(['/employee-list', id], { fragment: '1' });
          break;
        }
      case 'cnss-reports':
        {
          this.router.navigate(['/cnss-reports', id]);
          break;
        }
      case 'cnamgs-report':
        {
          this.router.navigate(['/cnamgs-report', id]);
          break;
        }
      case 'cnss-report-view':
        {
          this.router.navigate(['/cnss-report-view', id]);
          break;
        }
      case 'cnamgs-reportview':
        {
          this.router.navigate(['/cnamgs-reportview', id]);
          break;
        }
    }
  }
}
